import React from "react";
// eslint-disable-next-line import/no-unresolved
import Accessibility from "@regional/templates/Accessibility";

function AccessibilityPage() {
  return <Accessibility />;
}

export default AccessibilityPage;
